export default "__VITE_ASSET__c61717f1__"